module.exports = __webpack_public_path__ + "static/img/POCDiagramSample.40087c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/POCDiagramSample.png
// module id = 8ryz
// module chunks = 73